<template>
  <transition
    name="gh-card-slide"
    @enter="onEnter"
    @after-enter="onAfterEnter"
    @leave="onLeave"
    @after-leave="onAfterLeave"
  >
    <div v-show="expanded" class="gh-card-slide__wrap">
      <slot />
    </div>
  </transition>
</template>

<script>
export default {
  name: 'GenerationHistoryCardSlide',
  props: {
    expanded: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onEnter(el) {
      el.style.height = '0';
      el.style.overflow = 'hidden';
      void el.offsetHeight;
      el.style.transition = 'height 0.25s ease';
      el.style.height = `${el.scrollHeight}px`;
    },
    onAfterEnter(el) {
      el.style.height = '';
      el.style.overflow = '';
      el.style.transition = '';
    },
    onLeave(el) {
      el.style.height = `${el.scrollHeight}px`;
      el.style.overflow = 'hidden';
      void el.offsetHeight;
      el.style.transition = 'height 0.25s ease';
      el.style.height = '0';
    },
    onAfterLeave(el) {
      el.style.height = '';
      el.style.overflow = '';
      el.style.transition = '';
    },
  },
};
</script>
